import { render, staticRenderFns } from "./UpdateAdmin.vue?vue&type=template&id=587819b4&scoped=true"
import script from "./UpdateAdmin.vue?vue&type=script&lang=js"
export * from "./UpdateAdmin.vue?vue&type=script&lang=js"
import style0 from "./UpdateAdmin.vue?vue&type=style&index=0&id=587819b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587819b4",
  null
  
)

export default component.exports